module.exports = __webpack_public_path__ + "img/1548908382.05232bdb.jpg";